import { render, staticRenderFns } from "./SessionInfo.vue?vue&type=template&id=2258b2d4&scoped=true"
import script from "./SessionInfo.vue?vue&type=script&lang=js"
export * from "./SessionInfo.vue?vue&type=script&lang=js"
import style0 from "./SessionInfo.vue?vue&type=style&index=0&id=2258b2d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2258b2d4",
  null
  
)

export default component.exports